import React from 'react';
import ScheduledRecipeCard from './ScheduledRecipeCard';
import './CalendarDay.css';

const CalendarDay = ({ date, dayName, scheduledRecipes, isToday, onRecipeRemoved, user, onScheduleSuccess }) => {
  const formatDate = (date) => {
    return date.getDate();
  };

  const formatFullDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className={`calendar-day ${isToday ? 'today' : ''}`}>
      <div className="day-header">
        <div className="day-name">{dayName}</div>
        <div className="day-date">{formatDate(date)}</div>
      </div>
      
      <div className="day-content">
        {scheduledRecipes.length > 0 ? (
          <div className="scheduled-recipes">
            {scheduledRecipes.map((schedule) => (
              <ScheduledRecipeCard
                key={schedule.id}
                schedule={schedule}
                onRemoved={onRecipeRemoved}
                user={user}
                onScheduleSuccess={onScheduleSuccess}
              />
            ))}
          </div>
        ) : (
          <div className="empty-day">
            <span className="empty-text">No meals planned</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarDay;